import { Component, Injector } from '@angular/core';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-terms-and-conditions-to-read',
  templateUrl: './terms-and-conditions-to-read.component.html',
  styleUrls: ['./terms-and-conditions-to-read.component.scss']
})
export class TermsAndConditionsToReadComponent extends AppComponentBase {

  basicUrl: string = environment.basicUrl
  isEnvironmentDevelopment: boolean = environment.development ? true : false

  constructor (
    injector: Injector,
  ) {
    super(injector)
  }
}
